import * as React from 'react';
import { AlertCircle, Loader2 } from 'lucide-react';
import { Button } from '@/components/forms/ui/button';

type Props = {
  mode: 'create' | 'edit';
  isSubmitting: boolean;
  disabled?: boolean;
  hasErrors?: boolean;
};

export function SubmitButton({ mode, isSubmitting, disabled = false, hasErrors = false }: Props) {
  const idleLabel = mode === 'create' ? 'Create' : 'Update';
  const busyLabel = mode === 'create' ? 'Creating…' : 'Updating…';
  return (
    <Button
      type="submit"
      variant="blue"
      disabled={disabled || isSubmitting}
      data-testid="line-item-submit-button"
      data-has-errors={hasErrors ? 'true' : undefined}>
      {isSubmitting ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          {busyLabel}
        </>
      ) : (
        <>
          {hasErrors ? (
            <AlertCircle
              className="mr-2 h-4 w-4"
              aria-label="form has errors"
              data-testid="line-item-submit-button-error-icon"
            />
          ) : null}
          {idleLabel}
        </>
      )}
    </Button>
  );
}
